import {Fragment} from "react";
import Portal from "../../../layout/Portal";
import Modal from "../../../layout/Modal";
import ComponentConfig from "../../ComponentConfig";
import EmailTemplateList from "../../../editors/lists/EmailTemplateList";
import {loadComponent} from "../../../../utils/components";
import Button from "../../Button";
import React, {useState} from "react";

let modal = null;

export const EmailTemplateButton = (props) => {
    const [template, setTemplate] = useState(null);
    return <Fragment>
        <Portal>
            <Modal
                ref={(selectTemplateModal) => modal = selectTemplateModal}
                size="large"
                header="Sablonok"
                disabled={props.disabled || props.isLoading}
                buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default", disabled: props.disabled || props.isLoading},
                        onClose: true,
                        onClick: async () => {
                            try {
                                modal && modal.hide();
                            } catch (e) {

                            }
                        }
                    }
                ]}
            >
                <ComponentConfig componentName="EmailTemplate">
                    <EmailTemplateList loadForm={(template) => {
                        setTemplate(template);
                        modal && modal.hide();
                    }}/>
                </ComponentConfig>
            </Modal>
            {template && <Modal
                state="on"
                size="small"
                header="Biztos betöltöd?"
                disabled={props.disabled || props.isLoading}
                buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default", disabled: props.disabled || props.isLoading},
                        onClose: true,
                        onClick: async () => {
                            setTemplate(null);
                        }
                    },{
                        text: "Igen",
                        props: {color: "warning", disabled: props.disabled || props.isLoading},
                        onClick: async () => {
                            loadComponent("EmailTemplate", template, ["template","template_engine","replacement_engine"]).then((data) => {
                                props.saveChanges && props.saveChanges(data.template);
                                props.saveTemplateEngine && props.saveTemplateEngine(data.template_engine);
                                props.saveReplacementEngine && props.saveReplacementEngine(data.replacement_engine);
                                setTemplate(null);
                            });
                        }
                    }
                ]}
            >
                Ha betöltöd ezt a sablont, minden eddigi módosításod elvész!
            </Modal>}
        </Portal>
        <Button
            color="default"
            onClick={() => {
                setTemplate(null);
                modal && modal.focus();
            }}
            icon="dashboard"
            tooltip={"Template betöltés"}
            disabled={props.disabled || props.isLoading}
        />
    </Fragment>
}